import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer
        className={
          "footer footer-black" +
          (this.props.transparent !== undefined ? " footer-transparent" : "")
        }
      >
        <div
          className={
            "container" + (this.props.fluid !== undefined ? "-fluid" : "")
          }
        >
          <nav className="pull-left">
            <ul>
              <li>
                <a href="#home">Home</a>
              </li>
                <li>
                    <a href="#pages/login-page">Tenant Login</a>
                </li>
                <li>
                    <a href="#pages/login-kiosk-page">Kiosk Login</a>
                </li>
                <li>
                    <a href="#register">Register</a>
                </li>
                <li>
                    <a href="#pages/pricing-page">Pricing</a>
                </li>
                <li>
                    <a href="#Contact">Contact Us</a>
                </li>
                <li>
                    <a href="#Legal">Legal</a>
                </li>
            </ul>
          </nav>
            <p className="copyright pull-right white">
                &copy; {1900 + new Date().getYear()}{" "}
                <a href="http://www.gurueconsulting.com">GuRue Consulting, LLC</a>
            </p>
        </div>
      </footer>
    );
  }
}
export default Footer;




// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx